'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * It allows adding global/static elements to Dekk.
 * Elements render content and are usually pure functions or stateless
 * components.
 *
 * @public
 * @param {Object} props
 *   The properties
 * @param {(ReactElement|ReactElement[])} props.children
 *   One or more elements
 * @example
 * import Deck, {Elements} from '@dekk/deck'
 *
 * const Header = () => <header>Hello Dekk!</header>
 * export default (
 *   <Deck>
 *     <Elements>
 *       <Header/>
 *     </Elements>
 *   </Deck>
 * )
 */
var Elements = function Elements(props) {
  return props.children;
};

/**
 * @private
 */
Elements.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
};

exports.default = Elements;
//# sourceMappingURL=index.js.map